<template>
    <v-card>
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text>
            <v-sheet tile height="6vh" class="d-flex align-center">
                <v-btn icon @click="addDay(-1)">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn small class="primary ma-4" @click="setToday">
                    当月
                </v-btn>
                <v-btn icon @click="addDay(1)">
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-container>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col lg="3" sm="6" cols="12">
                            <v-select
                                v-model="shop_id"
                                :items="shops"
                                label="支店"
                                @change="changeShop"
                                style="min-width: min-content;"
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-container>
            </v-sheet>
            <v-sheet>
                <v-data-table
                    :headers="headers"
                    :items="events"
                    :server-items-length="events.length"
                    :loading="loading"
                    hide-default-footer
                    class="elevation-1"
                >
                <template v-slot:[`item.start_date`]="{ item }">
                        {{moment(item.start).format('MM/DD')}}
                    </template>
                    <template v-slot:[`item.start_time`]="{ item }">
                        {{moment(item.start).format('HH:mm')}}
                    </template>
                    <template v-slot:[`item.kind`]="{ item }">
                        {{CUSTOMER.EXEC_KIND.getName(item.kind)}}
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                        <v-btn light fab small :to="`customer/history/${item.customer_id}?id=${item.id}`" target="_blank">
                            経緯表
                        </v-btn>
                    </template>
                </v-data-table>
            </v-sheet>
        </v-card-text>
    </v-card>
</template>

<script>
import CUSTOMER from "@/consts/customer.js";
import moment from "moment";

export default {
    title: "Top",
    name: "top",
    data: () => ({
        headers: [
            { text: "名前", value: "name", align: "start", sortable: false },
            { text: "実施日", value: "start_date", align: "start", sortable: false },
            { text: "実施時刻", value: "start_time", align: "start", sortable: false },
            { text: "実施CO", value: "category", align: "start", sortable: false },
            { text: "取組区分", value: "kind", align: "center", sortable: false },
            { text: "フォロー内容", value: "note", align: "start", sortable: false, width: "50%" },
            { text: "", value: "action", align: "center", sortable: false },
        ],
        loading: true,

        CUSTOMER: CUSTOMER,
        moment:moment,
        events: [],
        counselors: [],
        value: moment().format("yyyy-MM-DD"),
        selectedEvent: {},

        shop_id: 0,
        shops: null,

    }),
    computed: {
        title() {
            return moment(this.value).format("yyyy年MM月");
        },
    },
    async mounted() {
        await this.getEvents();
    },
    methods: {
        async setToday() {
            this.value = moment().format("yyyy-MM-DD");
            await this.getEvents();
        },
        async addDay(val) {
            this.value = moment(this.value).add(val, 'M').format("yyyy-MM-DD");
            await this.getEvents();
        },
        async getShopId() {
            if(this.shops == null) {
                await this.$axios.get( `/api/v1/shop`)
                    .then( response => {
                        this.shops = [
                            ...response.data.shops,
                            {
                                value: 0,
                                text: "全て"
                            },
                        ];
                    })
                const shop_id = this.$store.state.user.shop_id || this.shops[0].value;
                this.shop_id = shop_id;
            }
            return this.shop_id;
        },
        async getEvents() {
            this.loading = true;
            const start = moment(this.value).format("yyyy-MM-01");
            const end = moment(start).add(1, 'M').add(-1,'d').format("yyyy-MM-DD");
            const shop_id = await this.getShopId();
            const query = `start=${start}&end=${end}`;
            await this.$axios.get( `/api/v1/calendar/tel?${query}&shop_id=${shop_id}`)
                .then( response => {
                    this.events = response.data.events.map(e => {
                        const counselor = response.data.counselors.find(c => c.id == e.counselor_id);
                        e.category = counselor ? counselor.name : "担当無し";
                        return e;
                    }).sort((a, b) => a.start - b.start);
                    this.counselors = response.data.counselors.map(c => c.name);
                })
                .catch( error => {
                    console.log(error);
                });
            this.loading = false;
        },
        changeShop() {
            this.getEvents();
        },
    },
};
</script>
